module.exports = __webpack_public_path__ + "img/205-4563f0.png";